/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  CHIRP-compatible version of nurturing owner information.
 *  <p>This is a CHIRP-compatible equivalent of {@code com.hubspot.nurturingowners.core.NurturingOwnerInfo}
 *  that can be used in CHIRP RPC messages.
 */

export const evaluateInAppRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInApp',
  auth: 'app',
  fingerprint: 'KDhTXICuQlXrifxQofJJG5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateInAppV2Rpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInAppV2',
  auth: 'app',
  fingerprint: 'KDhTXICuQlXrifxQofJJG5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSelfServiceEligibilityRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'getSelfServiceEligibility',
  auth: 'app',
  fingerprint: 'gyjaiV5kkrvzxx1SiW-VnJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const evaluateAssignabilityRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateAssignability',
  auth: 'app',
  fingerprint: 'BzoP5ZQn4ojUw8nX1l3VLpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};